import { render, staticRenderFns } from "./customer-event.vue?vue&type=template&id=fbb9da40&scoped=true&"
import script from "./customer-event.vue?vue&type=script&lang=js&"
export * from "./customer-event.vue?vue&type=script&lang=js&"
import style0 from "./customer-event.vue?vue&type=style&index=0&id=fbb9da40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb9da40",
  null
  
)

export default component.exports